/**
 * @generated SignedSource<<24eb897bcb92d9cee263ceb3b922f1e2>>
 * @relayHash 0feb27b7c87c797f1dcb2aa3de16ed96
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1e996341592b8748e7470656b64cde194c43241fc967a0068a34cd7da59175bd

import type { ConcreteRequest } from 'relay-runtime';
export type authContextProviderQuery$variables = Record<PropertyKey, never>;
export type authContextProviderQuery$data = {
  readonly me: {
    readonly user: {
      readonly accountId: string;
      readonly email?: string | null;
      readonly locale?: string | null;
      readonly name?: string;
      readonly picture?: AGG$URL;
    };
  };
};
export type authContextProviderQuery = {
  response: authContextProviderQuery$data;
  variables: authContextProviderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v1 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "picture"
    },
    {
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "kind": "ScalarField",
      "name": "email"
    },
    {
      "kind": "ScalarField",
      "name": "locale"
    }
  ],
  "type": "AtlassianAccountUser"
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "authContextProviderQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "AuthenticationContext",
          "kind": "LinkedField",
          "name": "me",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  {
                    "kind": "RequiredField",
                    "field": (v0/*: any*/),
                    "action": "THROW"
                  },
                  (v1/*: any*/)
                ]
              },
              "action": "THROW"
            }
          ]
        },
        "action": "THROW"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "authContextProviderQuery",
    "selections": [
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              (v0/*: any*/),
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "name": "id"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "1e996341592b8748e7470656b64cde194c43241fc967a0068a34cd7da59175bd",
    "metadata": {},
    "name": "authContextProviderQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "c2b8e75c9ecbb2325a843ea26f6d5ab8";

export default node;
